import React from 'react';

import {
  styled,
  Typography
} from '@mui/material';



const StyledSection = styled('section')(({ theme }) => ({
  background: '#F0F7FA',
  padding: theme.spacing(4),
  borderRadius: +theme.shape.borderRadius * 2
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));



export interface IProps {
  title: string;
  children?: React.ReactNode | React.ReactNode[];
}

export const FC: React.FC<IProps> = props => {
  return (
    <StyledSection>
      <StyledTitle variant="h2">{props.title}</StyledTitle>

      {props.children}
    </StyledSection>
  );
};
